export default "__VITE_ASSET__Fq02uQsp__"